// "Powered by Locate2u" footer used on the auth screens. The Locate2u line
// links to the marketing site (opens in a new tab). Centralised here so the
// link can never drift across the auth pages.
//
// `tone` adapts the text colour to its surface: the default slate reads on the
// white cards; `onDark` is for the gradient brand panels of the split login.
export function PoweredByFooter({ tone = 'default' }: { tone?: 'default' | 'onDark' }) {
  const toneCls = tone === 'onDark' ? 'text-white/70' : 'text-slate-500';
  return (
    <div className={`text-[10px] uppercase tracking-[0.2em] ${toneCls}`}>
      Powered by{' '}
      <a
        href="https://www.locate2u.com"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        Locate2u
      </a>
    </div>
  );
}
